import React, {Component} from "react";
import {connect} from "react-redux";
import {compose} from "redux";
import {withTranslation} from "react-i18next";
import {Player, ControlBar, BigPlayButton} from 'video-react';
import styles from "./style.css";
import StickersComponentsScannerHeader from "../../components/scanner-header";
import UQButton from "../../../../uq-ui/components/button";
import Icon from "../../../../icons/Icon";
import {mediaVideoStateSelector} from "../../../store/media-video/selectors";
import {onVideoSelected, videoDone} from "../../../store/media-video/actions";
import {setGoAppModalVisibility} from "../../../../layout/store/actions";
import {StickerCreateStepEnum} from "../../../domain/enums/StickerCreateStepEnum";
import {checkStepValidation} from "../../../store/create-llama/actions";
import Div100vh from "../../../../uq-ui/components/div-100";
import {
  createLlamaIdSelector,
  createStickerIdSelector,
  createStickerItemIdSelector
} from "../../../store/create-llama/selectors";
import goolgeAnalytics from '../../../../user/analytics/GoogleAnalytics';
class StickersScreensNewStickerMediaVideo extends Component {

  videoRef;

  constructor(props) {
    super(props);
    this.state = {
      isMuted: true
    };
  }

  componentDidMount() {
    goolgeAnalytics.setCurrentScreen('web-new-sticker-media-video');
    this.props.checkStepValidation(StickerCreateStepEnum.VideoConfigure);
  }

  onBackPressed = () => {
    this.props.history.push(`/${this.props.stickerItem}/${this.props.stickerId}/new`);
  };

  onDonePressed = () => {
    this.props.videoDone(this.videoRef);
  };

  onVideoRef = (videoRef) => {
    videoRef && videoRef.play();
    this.videoRef = videoRef;
  };

  onVideoBgClicked = (event) => {
    event.preventDefault();
    this.videoRef && this.videoRef.play();
  };

  _renderControls = () => {
    return (
      <div className={styles.doneControls}>
        <UQButton label={this.props.t('doneBtn')}
                  containerStyle={{minWidth: 140}}
                  theme="brand"
                  onPress={this.onDonePressed}/>
      </div>
    );
  };

  _renderVideoBg() {
    return (
      <div onClick={this.onVideoBgClicked}>
        <Player
          ref={this.onVideoRef}
          preload={'metadata'}
          autoPlay={true}
          loop={true}
          playsInline
          fluid={true}
          src={this.props.mediaState.originVideoPath}>
          <ControlBar disableCompletely={true}/>
          <BigPlayButton className={styles.BigPlayButton}/>
        </Player>
      </div>
    )
  }

  render() {
    return (
      <Div100vh className={styles.container}>
        <StickersComponentsScannerHeader
          theme="brand"
          title={this.props.t('headerTitle')}
          showBackBtn={true}
          onBack={this.onBackPressed}/>
        {this.props.mediaState.originVideoPath && this._renderVideoBg()}
        <div className={styles.doneControlsContainer}>
          {this._renderControls()}
        </div>
      </Div100vh>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    videoDone: (playerRef) => dispatch(videoDone(playerRef)),
    onVideoSelected: (file) => dispatch(onVideoSelected(file)),
    showAppModal: () => dispatch(setGoAppModalVisibility(true)),
    checkStepValidation: (stepEnum) => dispatch(checkStepValidation(stepEnum))
  }
};

const mapStateToProps = (state) => {
  return {
    stickerId: createStickerIdSelector(state),
    stickerItemId: createStickerItemIdSelector(state),
    mediaState: mediaVideoStateSelector(state),
  }
};

export default compose(
  withTranslation('scr-new-sticker-video'),
  connect(mapStateToProps, mapDispatchToProps)
)(StickersScreensNewStickerMediaVideo);
